<template>
  <div>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <h1 style="padding: 10px 15px 0">Настройка почтового домена</h1>

        <div style="padding: 10px 10px">
          <v-form ref="form" lazy-validation>
            <v-select
              v-model="selectedType"
              :items="domainTypes"
              item-text="label"
              item-value="value"
              label="Тип настройки"
              outline
              color="accent"
              class="field"
              style="width: 100%"
              required
            />

            <v-text-field
              v-model="patternInput"
              outline
              label="Паттерн"
              class="field"
              color="accent"
              style="width: 100%"
              :rules="patternRules"
              hint="Регулярное выражение для проверки email адресов"
              required
            />

            <v-text-field
              v-model="descriptionInput"
              outline
              label="Описание"
              class="field"
              color="accent"
              style="width: 100%"
              :rules="descriptionRules"
              required
            />

            <template v-if="selectedType === 'limit'">
              <v-text-field
                v-model="attemptsInput"
                outline
                label="Max attempts"
                class="field"
                color="accent"
                style="width: 100%"
                type="number"
                :rules="attemptsRules"
                @input="validateNumber('attemptsInput')"
              />

              <v-text-field
                v-model="decayInput"
                outline
                label="Decay seconds "
                class="field"
                color="accent"
                style="width: 100%"
                type="number"
                :rules="decayRules"
                @input="validateNumber('decayInput')"
              />
            </template>
          </v-form>

          <v-card-actions>
            <v-spacer />
            <v-btn flat :disabled="!isValid" @click="confirmSettings"> Подтвердить </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from '../../../helpers/user'
import { editEmailDomain, setEmailDomain } from '../../../api/banners'

export default {
  name: 'EmailDomainModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      selectedType: 'block',
      domainTypes: [
        { label: 'Block', value: 'block' },
        { label: 'Limit', value: 'limit' },
        { label: 'Logout', value: 'logout' }
      ],
      dialog: this.value,
      patternInput: '',
      descriptionInput: '',
      attemptsInput: 0,
      decayInput: 0,
      showValidation: false,
      originalData: {}
    }
  },
  computed: {
    isValid () {
      if (!this.patternInput || !this.patternInput.trim()) return false
      if (!this.descriptionInput || !this.descriptionInput.trim()) return false
      if (this.selectedType === 'limit') return this.attemptsInput > 0 && this.decayInput > 0

      if (this.item) {
        const currentData = this.getCurrentData()
        const hasChanges = !this.isEqual(this.originalData, currentData)
        if (!hasChanges) return false
      }

      return true
    },
    patternRules () {
      return [
        v => {
          if (!v || v.trim() === '') return 'Поле "Паттерн" обязательно'

          try {
            this.validateRegexPattern(v)
            return true
          } catch (e) {
            return 'Некорректное регулярное выражение'
          }
        }
      ]
    },
    descriptionRules () {
      return [
        v => (!!v && v.trim() !== '') || 'Поле "Описание" обязательно'
      ]
    },
    attemptsRules () {
      return [
        v => {
          if (this.selectedType !== 'limit') return true
          return v > 0 || 'Max attempts должно быть больше 0'
        }
      ]
    },
    decayRules () {
      return [
        v => {
          if (this.selectedType !== 'limit') return true
          return v > 0 || 'Decay seconds должно быть больше 0'
        }
      ]
    }
  },
  watch: {
    value (newVal) {
      this.dialog = newVal
      if (newVal) {
        this.initForm()
        if (this.$refs.form) this.$refs.form.resetValidation()
      }
    },
    dialog (newVal) {
      this.$emit('update:dialog', newVal)
      if (!newVal) this.resetForm()
    },
    selectedType () {
      if (this.$refs.form) this.$refs.form.resetValidation()
    }
  },
  methods: {
    initForm () {
      if (this.item) {
        this.selectedType = this.item.type || 'block'
        this.patternInput = this.item.pattern || ''
        this.descriptionInput = this.item.description || ''
        this.attemptsInput = this.item.max_attempts || 0
        this.decayInput = this.item.decay_seconds || 0
        this.originalData = this.getCurrentData()
      } else {
        this.resetForm()
      }
    },
    getCurrentData () {
      return {
        type: this.selectedType,
        pattern: this.patternInput.trim(),
        description: this.descriptionInput.trim(),
        is_active: true,
        max_attempts: Number(this.attemptsInput),
        decay_seconds: Number(this.decayInput)
      }
    },
    isEqual (obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2)
    },
    resetForm () {
      this.selectedType = 'block'
      this.patternInput = ''
      this.descriptionInput = ''
      this.attemptsInput = 0
      this.decayInput = 0
      this.showValidation = false
      this.originalData = {}
      if (this.$refs.form) this.$refs.form.resetValidation()
    },
    validateNumber (field) {
      if (isNaN(this[field])) this[field] = 0
    },
    validateRegexPattern (pattern) {
      try {
        let regexContent = pattern
        if (pattern.startsWith('/') && pattern.endsWith('/'))
          regexContent = pattern.slice(1, -1)

        RegExp(regexContent)

        return true
      } catch (e) {
        throw new Error('Invalid regex pattern')
      }
    },
    getUpdatedData () {
      const currentData = this.getCurrentData()
      const updatedData = {}

      Object.keys(currentData).forEach(key => {
        if (currentData[key] !== this.originalData[key])
          updatedData[key] = currentData[key]
      })

      return updatedData
    },
    confirmSettings () {
      if (this.$refs.form && !this.$refs.form.validate()) return
      this.showValidation = true

      if (!User.hasAccess()) {
        this.$emit('show-error', 'Нет прав')
        this.dialog = false
        return
      }

      if (!this.isValid) return

      let requestData
      let apiCall
      if (this.item) {
        requestData = this.getUpdatedData()
        apiCall = editEmailDomain(this.item.id, requestData)
      } else {
        requestData = this.getCurrentData()
        apiCall = setEmailDomain(requestData)
      }

      apiCall
        .then(() => {
          this.$root.$emit('update-domain-table')
          this.dialog = false
        })
        .catch(err => {
          this.$emit('show-error', err.response.data.message)
          this.dialog = false
        })
    }
  }
}
</script>
